module.exports = __webpack_public_path__ + "static/media/fullscreen_logo_white.361e21df.svg";